<div
    dropdown
    #dropdown="bs-dropdown"
    [insideClick]="true"
    class="spc-color-picker-button form-control pull-right"
    [dropup]="isDropup"
>
    <button
        type="button"
        dropdownToggle
        class="spc-color-picker-button-area"
        [style.background]="colorValue"
        [attr.aria-label]="ariaLabel"
    >
        <sp-transparent-icon [color]="colorValue" />
    </button>

    <div *dropdownMenu class="dropdown-menu color-picker-dropdown" [class.dropdown-menu-right]="!positionLeft">
        @if (dropdown.isOpen) {
            <sp-color-picker-dropdown
                [color]="colorValue?.toLowerCase()"
                [colorsPreset]="colorsPreset"
                [hideGradient]="hideGradient"
                (setColorEvent)="setColorHandler($event)"
                (setColorPresetEvent)="setColorPresetHandler($event)"
                (close)="dropdown.hide()"
            />
        }
    </div>
</div>
